// Import routing components
import routes from './routes';

ReactDOM.render(
  <div>{routes}</div>,document.getElementById('root')
);
